var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdgeConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m363.43,69.27h-142.38c-2.18,0-3.92,1.72-3.92,3.9v108.75c0,20.75-16.81,37.56-37.54,37.56h-23.48c-12.99,0-23.46,10.49-23.46,23.48v37.54c0,12.93,10.47,23.48,23.46,23.48h23.48c20.73,0,37.54,16.83,37.54,37.56v26.6c0,34.5,28.02,62.59,62.61,62.59h1.55c34.59,0,62.61-28.08,62.61-62.59v-1.57c0-34.59-28.02-62.59-62.61-62.59h-21.89c-20.73,0-37.56-16.83-37.56-37.56v-9.39c0-20.73,16.83-37.56,37.56-37.56h104.04c2.12,0,3.92-1.8,3.92-3.9V73.17c0-2.18-1.8-3.9-3.92-3.9Zm-168.96,212.73c-5.17,5.17-12.31,8.37-20.22,8.37-15.81,0-28.61-12.8-28.61-28.61,0-7.88,3.2-15.05,8.37-20.22,5.17-5.19,12.33-8.39,20.24-8.39s15.05,3.2,20.22,8.39c5.19,5.17,8.39,12.34,8.39,20.22s-3.2,15.05-8.39,20.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeConnect);
export default __webpack_public_path__ + "static/media/EdgeConnect.9613e277a9b88acc64a680ce593c866e.svg";
export { ForwardRef as ReactComponent };